<mat-dialog-content>
  <section class="text-[#353C40] flex flex-col gap-5">
    <h3 class="text-center text-[1.6rem] font-semibold tracking-tight">
      ⚠️ Unsaved Changes
    </h3>
    <p class="text-left text-[.85rem] font-medium">
      You have unsaved changes. If you leave this page, your changes will be
      lost. Do you want to continue?
    </p>
  </section>
</mat-dialog-content>
<mat-dialog-actions class="flex flex-col md:flex-row gap-7 w-full">
  <button class="md w-full md:flex-1" mat-dialog-close mat-stroked-button>
    Stay
  </button>
  <button [mat-dialog-close]="true" class="md w-full md:flex-1" mat-flat-button>
    Leave
  </button>
</mat-dialog-actions>
